import React from 'react';
import './register.css'; // Import the CSS file

const Register = () => {
  return (
    <div id="register" className="register-animation"></div>
  );
}

export default Register;